import React from "react";
import I18nServicePage from "@/components/I18nServicePage";
import { IMG } from "@/lib/config";

export default function Pcm() {
  return (
    <I18nServicePage
      i18nKey="pcm"
      image={IMG.pcm}
      testIdPrefix="pcm"
      accentClass="text-accent-lime"
      badge={{ src: "/brand/pcm_coach_accredite.png" }}
    />
  );
}
